// Copied into your app by RapidRailsUI (bin/rails rui:update).
// Don't edit this copy: the next update overwrites it. Fix it in the rapid_rails_ui gem.
import { Controller } from "@hotwired/stimulus"

/**
 * Range Controller
 * @gem rapid_rails_ui
 * @version 0.88.0
 *
 * Keeps a range slider's live value, aria-valuetext and filled track in step
 * with the input while it moves. The server renders all three correctly, so
 * the slider works without this; the controller only makes them live.
 *
 * Targets: input (the <input type="range">), output (optional live value)
 * Values: unit (String) appended to the shown value, e.g. "%"
 */
export default class extends Controller {
  static targets = ["input", "output"]
  static values = { unit: { type: String, default: "" } }

  connect() {
    this.update()
  }

  update() {
    const input = this.inputTarget
    const text = `${input.value}${this.unitValue}`
    input.setAttribute("aria-valuetext", text)
    input.style.setProperty("--rui-range-fill", `${this.fillPercent(input)}%`)
    if (this.hasOutputTarget) this.outputTarget.textContent = text
  }

  fillPercent(input) {
    const min = parseFloat(input.min || "0")
    const max = parseFloat(input.max || "100")
    if (!(max > min)) return 0
    const percent = ((parseFloat(input.value) - min) / (max - min)) * 100
    return Math.min(100, Math.max(0, Math.round(percent * 100) / 100))
  }
}
